/**
 * Catálogo: Tipo de unidad. Const portable (sin dependencias de framework),
 * listo para mover a un package @idc-forms/* cuando el back lo necesite.
 * Patrón const-as-enum (igual que packages/types).
 */
export const UnitType = {
  APARTMENT: 'APT',
  VILLA: 'V',
  HOUSE: 'C'
} as const

export type UnitType = (typeof UnitType)[keyof typeof UnitType]

export const UnitTypeLabel = {
  [UnitType.APARTMENT]: 'Apartamento',
  [UnitType.VILLA]: 'Villa',
  [UnitType.HOUSE]: 'Casa'
} as const satisfies Record<UnitType, string>

// Opciones listas para selectores / enumValues de variables.
export const UnitTypeOptions = Object.values(UnitType).map((value) => ({
  value: UnitTypeLabel[value], // el resolver expone el LABEL como valor de la variable
  label: UnitTypeLabel[value]
}))
